import DeleteForeverTwoToneIcon from '@mui/icons-material/DeleteForeverTwoTone';

const DeleteForeverIcon = (): JSX.Element => {
    return <DeleteForeverTwoToneIcon />;
};

export default DeleteForeverIcon;
